// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { trigger, state, style, animate, transition } from '@angular/animations';

export const environment = {
	production: false,
	//serviceApi: 'http://chronosfrotahomolog.it4d.com.br/laravel/api',
	serviceApi: 'http://127.0.0.1:8000/api',
	animacoes: trigger('loading-fade', [
		state('hidden', style({ opacity: 0, display: 'none' })),
		state('shown', style({ opacity: 1 })),
        transition('shown => hidden', animate('200ms ease-out'))
	]),
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
